export default __webpack_public_path__ + "static/media/2.2bd427d2.png";